/**
 * Типы-псевдонимы для «перечислений» и огибающих контракта. Схемы Zod
 * экспортируют значения, но не всегда отдельный тип, поэтому выводим его из
 * готовых доменных типов — без импорта zod в бандл клиента.
 */

import type {
  ApiError,
  Attachment,
  Backlog,
  Board,
  Comment,
  Issue,
  IssueCard,
  IssueSprintRef,
  Project,
  ServerEvent,
  Sprint,
  User,
} from '@tasks/contracts';

export type IssueType = IssueCard['type'];
export type Priority = IssueCard['priority'];
export type StatusCategory = Issue['status']['category'];
export type Resolution = NonNullable<Issue['resolution']>;
export type SprintState = Sprint['state'];
export type ProjectRole = NonNullable<Project['myRole']>;
export type GlobalRole = User['role'];
export type UserKind = User['kind'];
export type AgentRole = NonNullable<User['agentRole']>;
export type InvitationStatus = NonNullable<User['invitationStatus']>;
export type BoardType = Project['boardType'];
export type Swimlane = Board['swimlane'];
export type ErrorCode = ApiError['error']['code'];
export type BoardColumn = Board['columns'][number];
export type BoardLane = BoardColumn['lanes'][number];
export type IssueStatus = Issue['status'];
export type IssueEpicRef = NonNullable<Issue['epic']>;
export type IssueSprintRefValue = IssueSprintRef;
export type UserRef = Issue['reporter'];
export type AttachmentRef = Attachment;
export type CommentValue = Comment;
export type ServerEventValue = ServerEvent;

/** Группа спринта в бэклоге (docs/05 §7). */
export type SprintGroupView = Backlog['sprintGroups'][number];

/** Группа задач по эпику в бэклоге. */
export type EpicGroupView = Backlog['epicGroups'][number];

/** Огибающая коллекции (docs/05 §1). */
export type Page<T> = {
  readonly items: readonly T[];
  readonly total: number;
  readonly limit: number;
  readonly offset: number;
};

/** Категория статуса → CSS-переменная цвета полосы колонки. */
export const CATEGORY_COLOR_VAR: Record<StatusCategory, string> = {
  todo: 'var(--c-cat-todo)',
  in_progress: 'var(--c-cat-progress)',
  done: 'var(--c-cat-done)',
};

/** Приоритет → CSS-переменная цвета. */
export const PRIORITY_COLOR_VAR: Record<Priority, string> = {
  highest: 'var(--c-pri-highest)',
  high: 'var(--c-pri-high)',
  medium: 'var(--c-pri-medium)',
  low: 'var(--c-pri-low)',
  lowest: 'var(--c-pri-lowest)',
};
